var map = {
	"./audio-placeholder": 649,
	"./audio-placeholder.png": 649,
	"./avatar-missing": 546,
	"./avatar-missing.png": 546,
	"./avatar-missing.svg": 839,
	"./header-missing": 556,
	"./header-missing.png": 556,
	"./soapbox-logo": 557,
	"./soapbox-logo-white": 558,
	"./soapbox-logo-white.svg": 558,
	"./soapbox-logo.svg": 557,
	"./video-placeholder": 650,
	"./video-placeholder.png": 650,
	"./void": 651,
	"./void.png": 651,
	"./web-push/web-push-icon_expand": 761,
	"./web-push/web-push-icon_expand.png": 761,
	"./web-push/web-push-icon_favourite": 762,
	"./web-push/web-push-icon_favourite.png": 762,
	"./web-push/web-push-icon_reblog": 763,
	"./web-push/web-push-icon_reblog.png": 763
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 838;